import { render, staticRenderFns } from "./t20.vue?vue&type=template&id=06542cea&scoped=true&"
import script from "./t20.vue?vue&type=script&lang=js&"
export * from "./t20.vue?vue&type=script&lang=js&"
import style0 from "./t20.vue?vue&type=style&index=0&id=06542cea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06542cea",
  null
  
)

export default component.exports